/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { type WithSkuItemRequestBuilder, WithSkuItemRequestBuilderRequestsMetadata } from './item/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/product-families/variants
 */
export interface VariantsRequestBuilder extends BaseRequestBuilder<VariantsRequestBuilder> {
    /**
     * Gets an item from the MomentumAPI.api.productFamilies.variants.item collection
     * @param sku The product to return to a standalone SKU.
     * @returns {WithSkuItemRequestBuilder}
     */
     bySku(sku: string) : WithSkuItemRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const VariantsRequestBuilderUriTemplate = "{+baseurl}/api/product-families/variants";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const VariantsRequestBuilderNavigationMetadata: Record<Exclude<keyof VariantsRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    bySku: {
        requestsMetadata: WithSkuItemRequestBuilderRequestsMetadata,
        pathParametersMappings: ["sku"],
    },
};
/* tslint:enable */
/* eslint-enable */
